import { createContext } from 'react'
import { PylonContextValues } from './types'

export const PylonContext = createContext<PylonContextValues | undefined>(undefined)
